module.exports = __webpack_public_path__ + "static/media/image_7.d49e0a5c.png";